import * as Util from './util.js';

class Member
{
  // ---------------------------------------------------------------------------------------------------------
	// --	Member
	// ---------------------------------------------------------------------------------------------------------

  constructor(){

    //参照
    this.list = $(".p-top__memberList");
    this.modal = $(".p-top__memberModal");

    //ロックフラグ
    this.isLock = false;

    //ボタンアクション
    const holder = this;
    this.list.find(".p-top__memberListItem").each(function(index){
      const item = $(this);
      item.find(".p-top__memberListProfile >a").click(function(event){
        event.preventDefault();
        if(Util.isSP())
        {
          holder.showProfileByAccordion(item);
        }
        else
        {
          holder.showProfileByModal(item);
        }
      });
      item.find(".p-top__memberListProfile >a").on("touchend", function(e){
        const btn = $(this);
        btn.addClass("active");
        TweenMax.delayedCall(0.3, function(){
          btn.removeClass("active");
        })
      })
    });

    //モーダル閉じるボタン
    this.modal.find(".p-top__memberModalCloseBtn").click((e)=>{
      e.preventDefault();
      this.closeProfileModal();
    });
    this.modal.on("click", function(e) {
      if ( $(e.target).closest(".p-top__memberModalWrapper").length === 0 ){
        holder.closeProfileModal();
      }
		});

  }

  // ---------------------------------------------------------------------------------------------------------
	// --	アコーディオン
	// ---------------------------------------------------------------------------------------------------------

  showProfileByAccordion(item){

    //参照
    const detail = item.find(".p-top__memberListDetail");
    const wrapper = detail.find(".p-top__memberListDetail-wrapper");

    //閉じる
    if(item.hasClass("open"))
    {
      //クラス削除
      item.removeClass("open");

      //詳細閉じる
      TweenMax.killTweensOf(detail);
      TweenMax.to(detail, 0.3, {height:0});
    }
    //開く
    else
    {
      //クラス追加
      item.addClass("open");

      //内容の高さ
      const contsH = wrapper.outerHeight();

      //詳細開く
      TweenMax.killTweensOf(detail);
      TweenMax.to(detail, 0.6, {height:contsH, ease:Power2.easeInOut});
    }
  }

  // ---------------------------------------------------------------------------------------------------------
	// --	モーダル
	// ---------------------------------------------------------------------------------------------------------

  showProfileByModal(item){

    //ロック
    if(this.isLock) return;
    this.isLock = true;

    //参照
    const wrapper = this.modal.find(".p-top__memberModalWrapper");
    const closeBtn = this.modal.find(".p-top__memberModalCloseBtn");
    const profile = this.modal.find(".p-top__memberModalProfile");
    const detail = this.modal.find(".p-top__memberModalDetail");

    //古い情報を消す
    profile.empty();
    detail.empty();

    //選択されたアイテムの情報を反映
    profile.append(item.find(".jp-name").clone());
    profile.append(item.find(".jp-occupation").clone());
    profile.append(item.find(".en-name").clone());
    profile.append(item.find(".en-occupation").clone());
    detail.append(item.find(".jp-detail").clone());
    detail.append(item.find(".en-detail").clone());

    //Tween
    TweenMax.killTweensOf(this.modal);
    TweenMax.set(this.modal, {alpha:0});
    TweenMax.to(this.modal, 0.1, {alpha:1, ease:Power0.easeNone});
    this.modal.css("display", "flex");

    TweenMax.killTweensOf(wrapper);
    TweenMax.set(wrapper, {alpha:0, scaleX:0.95, scaleY:0.95});
    TweenMax.to(wrapper, 0.6, {alpha:1, scaleX:1.0, scaleY:1.0, delay:0.1, ease:Back.easeOut.config(1.7), onComplete:()=>{
      this.isLock = false;
    }});

    TweenMax.killTweensOf(closeBtn);
    TweenMax.set(closeBtn, {alpha:0});
    TweenMax.to(closeBtn, 0.6, {alpha:1, ease:Power0.easeNone, delay:0.6});
  }

  closeProfileModal(){

    //ロック
    if(this.isLock) return;
    this.isLock = true;

    TweenMax.killTweensOf(this.modal);
    TweenMax.to(this.modal, 0.1, {alpha:0, ease:Power0.easeNone, onComplete:()=>{
      this.isLock = false;
      this.modal.css("display", "none");
    }});
  }

  // ---------------------------------------------------------------------------------------------------------
}

export default Member;
